import React, { useState} from 'react';
import {
    List, Datagrid, TextField, FunctionField,
    SimpleList
} from 'react-admin';
import {
    useMediaQuery, makeStyles,FormControl, InputLabel, Select, MenuItem, Button
} from '@material-ui/core';
import { customTheme } from "./customTheme";
import ScrollableTable from './components/ScrollableTable';
import { vehicleSvgs } from "./sharedData";
import CustomSearch from './components/CustomSearch';
import ParkingSearchSelector from "./components/ParkingSearchSelector";
import { useLocation, useHistory } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import UseAnalyticsEvent from './utils/useAnalyticsEvent';
import CustomFilter from './components/CustomFilter';
import { generateReport } from './utils/generateReports';
import notify from './components/CustomUseNotify';
import GetAppIcon from "@material-ui/icons/GetApp";
import moment from "moment";

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
});

const CATEGORY = "PERMIT SLOT SECTION"

export const SlotInventory = props => {
    const eventTracker = UseAnalyticsEvent()
    const classes = useStyles();
    const location = useLocation();
    const navigate = useHistory()
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));

    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [viewOnly] = useState(sessionStorage.getItem("view_only") === "1");
    //const [allowCompanyUserCreate] = useState(sessionStorage.getItem("allow_company_user_create") === "1");
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});
    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));

    let searchTypeState = ["Slot Name", "Flat Number", "Tower Name",];
    const [search, setSearch] = useState(prevSearch.inputSearch);
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Slot Name");
    const [filterListValue, setFilterListValue] = useState(prevSearch.radioValue ? prevSearch.radioValue : null)

    let filterTypesInitState = [
        {
            resourcePath: "slotAreas",
            filterType: "Slot Area",
            dataList: [],
            searchList: [],
            listType: "Dynamic",
            resourceParam: "name",
            source: "slot_area",
            showFilter: true
        },
        {
            filterType: "Flat Tower",
            dataList: [{ name: "Assigned", id: 2 }, { name: "Empty", id: 3 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
        {
            filterType: "Vehicle Type",
            dataList: [ { name: "Bike", id: 2 }, { name: "Car", id: 4 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
    ]
    const [settingFilterFormat, setSettingFilterFormat] = useState({})
    const filter = {...settingFilterFormat, search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined };

    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    const renderVehicleType = row => (
        row.vehicle_type ?
            <div style={{ display: 'flex', alignItems: "center", justifyContent: "center" }}>
                <img src={vehicleSvgs[row.vehicle_type]} style={{ width: 25, height: 25, marginRight: 4 }} alt="Vehicle Icon" />
            </div>
            :
            <div style={{display: 'flex', alignItems: "center", justifyContent: "center"}}>
                <div style={{color: "#334D6E", backgroundColor: "#EBEFF2", fontSize:"9px", width:"65px", textAlign:"center", borderRadius:"5px"}}>unassigned</div>
            </div>
    );

    const fomattingFilter = (filterList) => {
		const result = {};
		if (filterList) {
			for (const obj of filterList) {
				const { filterType, value, id } = obj;
				result[filterType.replaceAll(" ", "_").toLowerCase()] = { value: value || "", id: id || "" };
			}
		}
		return result;
	}

    const reportParams = {
        access_key_ids: currentParking.allZones ? zoneIds : currentParking.id ? [currentParking.id] : undefined,
        report_name: "PERMIT_SLOTS",
        report_format: "xlsx",
        start_time: moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        end_time: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
        filters: filterListValue ? fomattingFilter(filterListValue) : undefined,
    };

    const reportHandler = async () => {
        const reportStatus = await generateReport(reportParams)
        if(reportStatus.success) navigate.push("/reports")
        else notify(reportStatus.message, "warning")
     }

    React.useEffect(() => {
        let values = {}
        // Add more types based on the filters
        if (filterListValue) {
            for (let val in filterListValue) {
                if (filterListValue[val].filterType === "Slot Area") {
                    values = { ...values, slot_area: filterListValue[val].value ? filterListValue[val].value : undefined }
                }
                if (filterListValue[val].filterType === "Flat Tower") {
                    values = { ...values, flat_tower: filterListValue[val].value ? filterListValue[val].value : undefined }
                }
                if (filterListValue[val].filterType === "Vehicle Type") {
                    values = { ...values, vehicle_type: filterListValue[val].id ? filterListValue[val].id : undefined }
                }
            }
            setSettingFilterFormat(values)
        }
        if (filterListValue === null) {
            setSettingFilterFormat({})
        }
    }, [filterListValue]) // eslint-disable-line react-hooks/exhaustive-deps

    React.useEffect(() => {
        eventTracker(CATEGORY, "INVENTORY LIST")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return <div className={classes.list}>
        <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
            {showFilter &&
                <ParkingSearchSelector
                    value={currentParking}
                    onChange={onParkingChange}
                    clearable={true}
                    pathName={location.pathname}
                />
            }

            {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                    <InputLabel>Zone Name</InputLabel>
                    <Select
                        value={currentParking.allZones ? "All" : currentParking.id}
                        onChange={onZoneChange}
                        label="Zone Name"
                        variant="outlined"
                    >
                        <MenuItem value="All">All</MenuItem>
                        {finalZones.map((zone, index) => (
                            <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
        </div>
        <div className='customStyleForDataSearchDiv'>
        <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
        <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} pathName={location.pathname} />
        {!viewOnly && <Button
                className='buttonStyle addBorderRadius'
                variant="contained"
                color="secondary"
                disableElevation
                size="small"
                onClick={reportHandler}
            >
                <GetAppIcon />
            </Button>
            }
        </div>
        <List
            style={{ marginTop: 20 }}
            {...props}
            title="Slots Inventory"
            bulkActionButtons={false}
            exporter={false}
            filter={filter}
            empty={false}
            hasCreate={!viewOnly}
            actions={false}
            pagination={<CustomPagination />}
        >
            {isSmallDevice ?
                <SimpleList
                    primaryText={record => null}
                    secondaryText={record => (<div>
                        <div style={{ color: customTheme.palette.secondary.main }}>{record["slot_name"] ? `Slot Name: ${record["slot_name"]}` : ""}</div>
                        <div style={{ color: customTheme.palette.secondary.main }}>{record["slot_area"] ? `Slot Area: ${record["slot_area"]}` : ""}</div>
                        <div style={{ color: customTheme.palette.secondary.main }}>{record["flat_number"] ? `Flat No: ${record["flat_number"]}` : ""}</div>
                        <div style={{ color: customTheme.palette.secondary.main }}>{record["tower_name"] ? `Tower Name: ${record["tower_name"]}` : ""}</div>
                        <div style={{ color: customTheme.palette.secondary.main }}>{record["parking_name"] ? `Parking Name: ${record["parking_name"]}` : ""}</div>
                        <div style={{display:"flex", justifyContent:"flex-start", alignItems:"center", gap: 10}}>Vehicle Type: {record && renderVehicleType(record)}</div>
                    </div>)}
                    onContextMenu={event => event.preventDefault()}
                    linkType={false}
                    rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                />
                :
                <Datagrid component={ScrollableTable}>
                    <TextField source="slot_name" label="Slot Name" />
                    <TextField source="slot_area" label="Slot Area" />
                    <TextField source="flat_number" label='Flat Number' />
                    <TextField source="tower_name" label="Tower Name" />
                    <FunctionField source="vehicle_type" label="Vehicle Type"render={record => record && renderVehicleType(record)}/>
                    <TextField source="parking_name" label="Parking Name" />
                </Datagrid>
            }
        </List>
    </div>
};